import { createAction, props } from '@ngrx/store';
import { ITransaction } from 'src/app/modules/customer-shared/models/IGlimpseReport';
import { ExtraCameraImage } from 'src/app/modules/report-components/models/ExtraCameraImage';
import { Dayjs } from 'dayjs';

const TAG = `[Image Browser]`;

export const initFromTransaction = createAction(
  `${TAG} Init From Transaction`,
  props<{ transaction: ITransaction; periodId: string; filterRegion: string; autoplay?: boolean }>(),
);
export const init = createAction(
  `${TAG} Init`,
  props<{
    cameraId: number;
    loopStart: Dayjs;
    loopEnd: Dayjs;
    start: Dayjs;
    periodId: string;
    filterRegion: string;
    autoplay?: boolean;
  }>(),
);

export const loadInitialImagesSuccess = createAction(
  `${TAG} Load Initial Images Success`,
  props<{
    images: ExtraCameraImage[];
  }>(),
);

export const goPrev = createAction(`${TAG} Go Prev`);
export const goNext = createAction(`${TAG} Go Next`, props<{ pause: boolean }>());
export const goPrevN = createAction(`${TAG} Go Prev N`, props<{ count: number }>());
export const goNextN = createAction(`${TAG} Go Next N`, props<{ count: number }>());
export const goTo = createAction(`${TAG} Go To`, props<{ index: number }>());
export const goToTimestamp = createAction(`${TAG} Go To Timestamp`, props<{ timestamp: number }>());
//the frames this camera can give do not reach the moment asked for, so the jump is given up on
export const jumpUnreachable = createAction(`${TAG} Jump Unreachable`);

export const play = createAction(`${TAG} Play`);
export const pause = createAction(`${TAG} Pause`);
export const togglePlay = createAction(`${TAG} Toggle Play`);
export const toggleLoop = createAction(`${TAG} Toggle Loop`);

export const imageLoaded = createAction(`${TAG} Image Loaded`);

// export const loadExtraImagesSuccess = createAction(
//   `${TAG} Load Extra Images Success`,
//   props<{ images: ExtraCameraImage[]; fromIndex: number; before: number; after: number }>(),
// );
export const loadExtraImagesError = createAction(`${TAG} Load Extra Images Error`, props<{ error: Error }>());

export const loadImagesBefore = createAction(
  `${TAG} Load Images Before`,
  props<{
    fromIndex: number;
    before: number;
  }>(),
);
export const loadImagesBeforeSuccess = createAction(
  `${TAG} Load Images Before Success`,
  props<{ images: ExtraCameraImage[]; fromIndex: number; before: number }>(),
);
export const loadImagesBeforeError = createAction(`${TAG} Load Images Before Error`, props<{ error: Error }>());

export const loadImagesAfter = createAction(`${TAG} Load Images After`, props<{ fromIndex: number; after: number }>());
export const loadImagesAfterSuccess = createAction(
  `${TAG} Load Images After Success`,
  props<{ images: ExtraCameraImage[]; fromIndex: number; after: number }>(),
);
export const loadImagesAfterError = createAction(`${TAG} Load Images After Error`, props<{ error: Error }>());
export const selectedCameraChanged = createAction(`${TAG} Selected Camera Changed`, props<{ cameraIds: number[] }>());
export const loadExtraCamera = createAction(`${TAG} Load Extra Camera`, props<{ cameraId: number; start: Dayjs }>());
export const loadExtraCameraSuccess = createAction(
  `${TAG} Load Extra Camera Success`,
  props<{ cameraId: number; start: Dayjs; images: ExtraCameraImage[] }>(),
);
